module.exports = __webpack_public_path__ + "media/images/pages/contributor_overview/img-13-12527378e88119c417c642e105df1588.png";